import { render, staticRenderFns } from "./LayoutMask.vue?vue&type=template&id=dfda13d4&"
import script from "./LayoutMask.vue?vue&type=script&lang=js&"
export * from "./LayoutMask.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports